/**
 * @generated SignedSource<<169509d56041966e298998cb87a38e17>>
 * @relayHash 356127a3390d1de988ecf2b4a1c1a03c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateConfluenceRemoteIssueLinksFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraConfluenceRemoteIssueLinksFieldOperationInput>;
};
export type JiraConfluenceRemoteIssueLinksFieldOperationInput = {
  links: ReadonlyArray<JiraConfluenceRemoteIssueLinkInput>;
  operation: JiraMultiValueFieldOperations;
};
export type JiraConfluenceRemoteIssueLinkInput = {
  href?: string | null | undefined;
  id?: string | null | undefined;
};
export type confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$variables = {
  input: JiraUpdateConfluenceRemoteIssueLinksFieldInput;
  isJiraConfluencePageContentEnabled: boolean;
};
export type confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$data = {
  readonly jira: {
    readonly updateConfluenceRemoteIssueLinksField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly confluenceRemoteIssueLinks: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly href: string | null | undefined;
              readonly id: string;
              readonly pageContent?: {
                readonly href?: string | null | undefined;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$rawResponse = {
  readonly jira: {
    readonly updateConfluenceRemoteIssueLinksField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly confluenceRemoteIssueLinks: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly href: string | null | undefined;
              readonly id: string;
              readonly pageContent: {
                readonly __typename: "JiraConfluencePageContentDetails";
                readonly href: string | null | undefined;
              } | {
                readonly __typename: string;
              } | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number | null | undefined;
        } | null | undefined;
        readonly id: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation = {
  rawResponse: confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$rawResponse;
  response: confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$data;
  variables: confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isJiraConfluencePageContentEnabled"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "ScalarField",
  "name": "href"
},
v8 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/)
  ],
  "type": "JiraConfluencePageContentDetails"
},
v9 = [
  {
    "kind": "LinkedField",
    "name": "pageContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      (v8/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
            "kind": "LinkedField",
            "name": "updateConfluenceRemoteIssueLinksField",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraConfluenceRemoteIssueLinksField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView"
                  },
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "confluenceRemoteIssueLinks",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraConfluenceRemoteIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "condition": "isJiraConfluencePageContentEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "pageContent",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraUpdateConfluenceRemoteIssueLinksFieldPayload",
            "kind": "LinkedField",
            "name": "updateConfluenceRemoteIssueLinksField",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "concreteType": "JiraConfluenceRemoteIssueLinksField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "args": (v5/*: any*/),
                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                    "kind": "LinkedField",
                    "name": "confluenceRemoteIssueLinks",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraConfluenceRemoteIssueLink",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": (v9/*: any*/)
                              },
                              {
                                "condition": "isJiraConfluencePageContentEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": (v9/*: any*/)
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalCount"
                      }
                    ],
                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c7b140651da7182c815fbb41a5ffa4914e5873e27f703bb3bf555585dc1ffb61",
    "metadata": {},
    "name": "confluencePages_issueFieldConfluencePagesInlineEditFull_Mutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};
})();

(node as any).hash = "6df37fe378e93b2269d708c82fda03c4";

export default node;
